<template>
    <div class="stage-details">
        <div class="details-form-wrapper">
            <div class="details-field half titlefield">
                <input type="text" name="title" id="title" v-model="honeyPot" />
            </div>
            <template v-if="$store.state.customerType === 'contractor'">
                <div class="details-field full contractor-banner">
                    <div class="contractor-banner-inner">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                        <span>Contractor Account — please provide your business details below</span>
                    </div>
                </div>
                <div class="details-field half">
                    <label for="vat_number">VAT Number<span class="required">*</span></label>
                    <input type="text" name="vat_number" id="vat_number" v-model="vatNumber" placeholder="e.g. 4012345678" />
                </div>
                <div class="details-field half">
                    <label for="registration_number">Registration Number<span class="required">*</span></label>
                    <input type="text" name="registration_number" id="registration_number" v-model="registrationNumber" placeholder="e.g. 2023/123456/07" />
                </div>
                <div class="details-field full contractor-note">
                    <em>* At least one of VAT Number or Registration Number is required for contractor accounts.</em>
                </div>
            </template>
            <div class="details-field half">
                <label for="name">Your Name<span class="required">*</span></label>
                <input type="text" name="name" id="name" v-model="yourName" />
            </div>
            <div class="details-field half">
                <label for="phonenumber">Phone Number</label>
                <input type="tel" name="phonenumber" id="phonenumber" v-model="number" />
            </div>
            <div class="details-field full">
                <label for="email">Email Address<span class="required">*</span></label>
                <input type="email" name="email" id="email" v-model="email" />
            </div>
            <div class="details-field full" v-if="$store.state.customerType === 'private'">
                <label for="discount_code">Discount Code</label>
                <input type="text" name="discount_code" id="discount_code" v-model="discountCode" autocomplete="off" />
                <p class="field-note" v-if="$store.getters.discountCodeIsApplied">
                    {{ $store.getters.discountPercent }}% discount applied to product prices.
                </p>
            </div>
            <div class="details-field full spaced-inline">
                <label for="receiving">How would you like to receive your products?<span class="required">*</span></label>
                <span class="radio-options">
                    <span class="radio-button">
                        <input type="radio" name="receiving" id="receiving" value="collection" v-model="receivingType" />
                        <span class="radio-button-inner">Collection</span>
                    </span>
                    <span class="radio-button">
                        <input type="radio" name="receiving" id="receiving" value="delivery" v-model="receivingType" />
                        <span class="radio-button-inner">Delivery</span>
                    </span>
                </span>
            </div>
            <div class="details-field full" v-show="$store.state.contactDetails.receivingType === 'delivery'">
                <label>Your Address for Delivery<span class="required">*</span></label>
                <AddressAutocomplete v-model="deliveryDetails" :origin="origin" />
            </div>
            <div class="details-field full" v-show="deliveryDetails?.address">
                <div class="address-title">You entered the following address for delivery</div>
                <div class="address">{{ addressDisplay }}</div>
            </div>
            <div class="details-field full">
                <label for="comments">Do you have any additional comments?</label>
                <textarea name="comments" id="comments" rows="5" v-model="message"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import AddressAutocomplete from '@/components/address-autocomplete.vue';
export default {
    name: 'stage-details',
    data() {
        return {
            origin: {
                lat: -25.770889,
                lng: 28.147472
            }
        };
    },
    components: {
        AddressAutocomplete
    },
    computed: {
        addressDisplay: function () {
            if (!this.deliveryDetails?.address) return '';
            const a = this.deliveryDetails.address;
            if (typeof a === 'string') return a;
            return [
                (a.street_number || '') + ' ' + (a.street_name || ''),
                a.suburb, a.city, a.province, a.country, a.postal_code
            ].filter(Boolean).join(', ');
        },
        honeyPot: {
            get() {
                return this.$store.state.honeypot;
            },
            set(value) {
                this.$store.commit('setHoneypot', value);
            }
        },
        yourName: {
            get() {
                return this.$store.state.contactDetails.name;
            },
            set(value) {
                this.$store.commit('updateContactDetails', {
                    name: value
                });
            }
        },
        number: {
            get() {
                return this.$store.state.contactDetails.number;
            },
            set(value) {
                this.$store.commit('updateContactDetails', {
                    number: value
                });
            }
        },
        email: {
            get() {
                return this.$store.state.contactDetails.email;
            },
            set(value) {
                this.$store.commit('updateContactDetails', {
                    email: value
                });
            }
        },
        receivingType: {
            get() {
                return this.$store.state.contactDetails.receivingType;
            },
            set(value) {
                this.$store.commit('updateContactDetails', {
                    receivingType: value
                });
            }
        },
        message: {
            get() {
                return this.$store.state.contactDetails.message;
            },
            set(value) {
                this.$store.commit('updateContactDetails', {
                    message: value
                });
            }
        },
        deliveryDetails: {
            get() {
                return this.$store.state.deliveryDetails;
            },
            set(value) {
                this.$store.commit('updateDeliveryDetails', value);
            }
        },
        vatNumber: {
            get() {
                return this.$store.state.contractorDetails.vatNumber;
            },
            set(value) {
                this.$store.commit('updateContractorDetails', { vatNumber: value });
            }
        },
        registrationNumber: {
            get() {
                return this.$store.state.contractorDetails.registrationNumber;
            },
            set(value) {
                this.$store.commit('updateContractorDetails', { registrationNumber: value });
            }
        },
        discountCode: {
            get() {
                return this.$store.state.discountCode;
            },
            set(value) {
                this.$store.commit('updateDiscountCode', value);
                if (this.$store.state.cart.length > 0) {
                    this.$store.dispatch('calculateFinalResults');
                }
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.details-form-wrapper {
    display: flex;
    flex-flow: row wrap;
    margin-left: -20px;
    margin-right: -20px;

    .details-field {
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px;

        &.titlefield {
            overflow: hidden;
            width: 0 !important;
            height: 0 !important;
            opacity: 0 !important;
            pointer-events: none;
            margin: 0 !important;
            padding: 0 !important;
            visibility: hidden !important;
        }

        .required {
            color: red;
        }

        label {
            display: block;
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 5px;
            // letter-spacing: 0.5px;
        }
        .field-note {
            margin: 6px 0 0;
            color: #2e7d32;
            font-size: 13px;
        }
        input[type='text'],
        input[type='tel'],
        input[type='email'] {
            width: 100%;
            box-sizing: border-box;
            outline: none;
            border: 0;
            background-color: #efefef;
            height: 40px;
            line-height: 40px;
            padding: 0 12px;
            border: 1px solid #cecece;
            &:focus,
            &:active {
                border: 1px solid $cl-primary;
            }
        }

        &.contractor-banner {
            background-color: transparentize($cl-primary, 0.92);
            border-left: 3px solid $cl-primary;
            padding: 12px 16px !important;
            margin-bottom: 20px;
            .contractor-banner-inner {
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 14px;
                font-weight: 600;
                color: darken($cl-primary, 10%);
                svg {
                    flex-shrink: 0;
                }
            }
        }

        &.contractor-note {
            em {
                font-size: 13px;
                color: #888;
            }
        }

        &.half {
            width: 50%;
            @media screen and (max-width: 768px) {
                width: 100%;
            }
        }

        &:not(:last-child) {
            margin-bottom: 20px;
        }

        &.spaced-inline {
            display: flex;
            align-items: center;
            justify-content: space-between;

            @media screen and (max-width: 768px) {
                flex-flow: row wrap;
            }

            label {
                font-size: 16px;
            }

            .radio-button {
                &:not(:last-child) {
                    margin-right: 10px;
                }
            }
        }

        .address-title {
            font-weight: 600;
            & + .address {
                font-style: italic;
            }
        }
    }
}
</style>